import React, { useEffect } from 'react';
import { CloseButton, Modal } from 'react-bootstrap';
import styles from './StaticProductDetails.module.scss';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';

interface GenericModalSchema {
  modalState: boolean;
  handler: () => void;
  children: React.ReactNode; // modal body
  showFooter: boolean;
  footerNode?: React.ReactNode;
  height?: string;
  width?: string;
  backDrop?: boolean;
  backButton?: string;
}

const ProductDetailsModal = ({
  modalState,
  handler,
  showFooter,
  footerNode,
  children,
  width,
  height,
  backButton
}: GenericModalSchema): any => {
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();

  useEffect(() => {
    const elem4: any = document && document?.querySelector('.product-modal .footer-main');
    if (elem4) {
      elem4.style.zIndex = '10';
    }
    const elem: any = document && document?.querySelector('.modal-dialog.product-modal');
    if (elem) {
      elem.style.maxWidth = width;
      elem.style.padding = '0';
      elem.style.transform = 'none';
    }
    const elem1: any = document && document?.querySelector('.product-modal .modal-content');
    if (elem1) {
      elem1.style.height = height;
      elem1.style.backgroundColor = '#F7F6F5';
    }
    const elem2: any = document && document.querySelector('.product-modal .modal-header');
    if (elem2) {
      elem2.style.position = 'absolute';
      elem2.style.top = '0';
      elem2.style.zIndex = '1';
      elem2.style.maxWidth = '100%';
      elem2.style.background = '#f8f8f8';
      elem2.style.width = '100%';
    }
    const elem3: any = document && document.querySelector('.product-modal .modal-body');
    if (elem3) {
      elem3.style.background = '#f8f8f8';
      elem3.style.paddingTop = '70px';
    }
  }, [height]);

  return (
    <Modal
      scrollable={false}
      show={modalState}
      onHide={handler}
      keyboard={false}
      dialogClassName={styles.productPopModal}
    >
      <Modal.Header>
        <div onClick={handler} className={`${styles.container}`}>
          <>
            <img
              src={`${assetPath}/icons/arrow-left-red.svg`}
              alt={'arrow'}
              height={24}
              width={24}
              className='me-3'
            />
            <span className={styles.backbtn}>{backButton}</span>
          </>
        </div>
        <div className={`${styles.closebtn} me-3 mt-3`}>
          <CloseButton className='sr-modal-close' onClick={handler} />
        </div>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {showFooter && <Modal.Footer>{footerNode}</Modal.Footer>}
    </Modal>
  );
};

export default ProductDetailsModal;
